export default __webpack_public_path__ + "static/media/customKitchen5CroppedRight.e961da51.jpeg";